import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const route = api(root);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

const NonStatutoryAdviceServices = {
  async getNonStatutoryAdviceReviewer({
    pageSize,
    pageNumber,
    approvalStatus,
    search,
  }) {
    try {
      let { data } = await route.get(
        `/NonStatutoryAdvise/GetAllNonStatutoryAdviceQuery?PageSize=${pageSize}&PageNumber=${pageNumber}&ApprovalStatus=${approvalStatus}&Search=${search}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
};

export default NonStatutoryAdviceServices;
